import _ from "lodash";
import React, { useState, useEffect } from "react";

import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";
import { Error400 } from "views/pages";
import IntlMessages from "util/intlMessages";
import ContentTable from "./Table";
import { PageTitle } from "components/standart";
import AddContent from "./Add";
import ContentInfo from "./Info";

const ImageStyles = (props) => {
  const { url, path } = useRouteMatch();
  const { breadCrumbs } = props;

  const contentInfo = (style) => {
    return `${url}/style_${style._id}`;
  };

  const contentForm = (style) => {
    return `${contentInfo(style)}/form`;
  };

  breadCrumbs.push({
    title: <IntlMessages id="ImageStyles" />,
    url,
    actions: [<AddContent {...{ contentForm }} />],
  });

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <PageTitle {...breadCrumbs} />

        <ContentTable {...{ contentInfo, contentForm }} />
      </Route>

      <Route path={`${path}/style_:styleId`}>
        <ContentInfo {...{ breadCrumbs, contentInfo, contentForm }} />
      </Route>

      <Route component={Error400} />
    </Switch>
  );
};

export default ImageStyles;
